import React, { useEffect } from 'react';
import Dashboard from './client/Components/Body/Dashboard';
import { useDocumentTitle } from './client/Components/hooks/useDocuemntTitle';
import {getJWT} from './client/redux/userProfile/userAction'
import { useDispatch, useSelector } from "react-redux";

import './client/assets/font-awesome.min.css';
import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

function App({accountInfo,logout}:any): JSX.Element {
  let dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getJWT(accountInfo));
  },[accountInfo])

  useDocumentTitle()
  return (
    <div className='app'>
      <Dashboard logout={logout}/>
    </div>
  );
}

export default App;